module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8f53648c1514a11895ff2c933f5753d6.png";